import logger from './utils/logger.js';
import { formatProductName } from './utils/product.js';

// Function: Pushes view_item_list event to dataLayer
// Specs:
// - This function should be called on the category page, after the category items have been loaded
//
// More Info: https://hotelsathome.atlassian.net/wiki/spaces/D2/pages/2995191809/DataLayer+Reference+for+Analytics+-+Adobe+Launch+and+Google+Tag+Manager#Category-Page
const dataLayerFeaturedProductsAccor = ({ brand, items, itemListName, siteFilters = null, }) => {
    const currencyCode = items[0].price_range.minimum_price.regular_price.currency;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'view_item_list',
        event_value: null,
        event_items: items.map(el => ({
            google_business_vertical: 'retail',
            id: el.sku,
        })),
        ecommerce: {
            currency: currencyCode,
            items: items.map((el, idx) => {
                var _a, _b;
                return ({
                    index: idx,
                    item_id: el.sku,
                    item_name: formatProductName({
                        name: ((_a = el.name_en) === null || _a === void 0 ? void 0 : _a.product_name) || el.name,
                        lang: 'en',
                        siteFilters: siteFilters || null,
                    }),
                    item_category: ((_b = [...el.name_en.categories].reverse()[0]) === null || _b === void 0 ? void 0 : _b.name_en) || '',
                    item_brand: brand,
                    price: el.price_range.maximum_price.final_price.value,
                    item_list_name: itemListName,
                });
            }),
            item_list_name: itemListName,
        },
    });
    logger('view_item_list event pushed to dataLayer', { category: 'analytics' });
};

export { dataLayerFeaturedProductsAccor as d };
//# sourceMappingURL=featuredProducts-00rJtoMw.js.map
